import React from 'react';

import Image from 'next/legacy/image';

import { useTheme } from '@repo/ui/theming';
import PropTypes from 'prop-types';

import { useEditorAndDashboardUpdateFeature } from 'global/growthbookUtils';
import { LayoutSwitch } from 'styles/queries';

const NothingFoundIllustration = ({ alt = 'Nothing Found' }) => {
  const { isDarkTheme } = useTheme();
  const isNewDesignEnabled = useEditorAndDashboardUpdateFeature();

  return (
    <LayoutSwitch
      desktopProps={{
        height: isNewDesignEnabled ? '160px' : '280px',
        width: isNewDesignEnabled ? '160px' : '355px',
      }}
      mobileProps={{ height: '140px', width: '177px' }}
    >
      <Image
        alt={alt}
        className="nothing-found-illustration"
        height="280"
        src={
          isDarkTheme
            ? '/images/newTheme/dark/Empty.png'
            : '/images/newTheme/light/Empty.png'
        }
        width="355"
      />
    </LayoutSwitch>
  );
};

NothingFoundIllustration.propTypes = {
  /**
   * alt label of the illustration
   */
  alt: PropTypes.string,
};

export default NothingFoundIllustration;
